import Record from '@/page/modules/uc/record'
import Fav from '@/page/modules/uc/fav'
import Examination from '@/page/modules/uc/examination'
import EnrollUC from '@/page/modules/uc/enroll'
import Quiz from '@/page/modules/uc/quiz'
import Certificate from '@/page/modules/uc/certificate'
import Message from '@/page/modules/uc/message'
import Set from '@/page/modules/uc/Set'
import Order from '@/page/modules/uc/Order'
import Invoice from '@/page/modules/uc/invoice'
import LearnRecord from '@/page/modules/uc/learnrecord'

const routes = [
  {
    path: '/uc/record',
    name: '个人中心学习记录',
    component: Record
  },
  {
    path: '/uc/fav',
    name: '个人中心我的收藏',
    component: Fav
  },
  {
    path: '/uc/examination',
    name: '个人中心我的考试',
    component: Examination
  },
  {
    path: '/uc/questionnaire',
    name: '个人中心我的问卷',
    component: Quiz
  },
  {
    path: '/uc/enroll',
    name: '个人中心我的报名',
    component: EnrollUC
  },
  {
    path: '/uc/lrecord',
    name: '个人中心我的证书',
    component: LearnRecord
  },
  {
    path: '/uc/message',
    name: '个人中心我的消息',
    component: Message
  },
  {
    path: '/uc/set',
    name: '个人中心系统设置',
    component: Set
  },
  {
    path: '/uc/order',
    name: '个人中心我的订单',
    component: Order
  },
  {
    path: '/uc/invoice',
    name: '个人中心我的开票',
    component: Invoice
  }
]
export default routes



// WEBPACK FOOTER //
// ./src/routers/uc.js